import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchPictures() {
  try {
    const pictures = yield call(function() {
      return Api.get('/dealer/pictures')
    });
    yield put({type: 'FETCH_PICTURES.SUCCESS', pictures});
  } catch (error) {
    yield put({type: 'FETCH_PICTURES.FAILURE', error});
  }
}

function* savePictures(action) {
  try {
    const pictures = yield call(function() {
      return Api.post('/dealer/pictures', action.body)
    });

    yield put({type: 'SHOW_NOTIFICATION', notification:{message:'save.success'}});
    yield put({type: 'SAVE_PICTURES.SUCCESS'});
    yield put({type: 'FETCH_PICTURES.SUCCESS', pictures});
  } catch (error) {
    yield put({type: 'SAVE_PICTURES.FAILURE', error});
  }
}

export function* watchFetchPictures() {
  yield takeEvery('FETCH_PICTURES.REQUEST', fetchPictures);
  yield takeEvery('SAVE_PICTURES.REQUEST', savePictures);
}
